import StyledDeleteButton from './StyledDeleteButton';
import { ListItemIcon } from '@mui/material';
import { type ActionMenuButtonProps } from '../ActionMenuButton';
import { Delete as DeleteIcon } from '@mui/icons-material';

const ActionMenuDeleteButton = ({
  children,
  ...props
}: ActionMenuButtonProps) => (
  <StyledDeleteButton {...props}>
    <ListItemIcon>
      <DeleteIcon color="error" />
    </ListItemIcon>
    {children}
  </StyledDeleteButton>
);

export default ActionMenuDeleteButton;
